import getHomeAwayData from './getHomeAwayData';

const getMatchName = (matchData) => {
  if (!matchData) return '';
  const { homeTeam, awayTeam } = getHomeAwayData(matchData);
  return `${homeTeam.name} v ${awayTeam.name}`;
};

export default getMatchName;
